import { EQUAL_WEIGHTS_TITLE } from '@upright/common/model/data';
import { useNetScoreWithoutValueSet } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result/common/use-net-score';
import { useAggregateResultAreaLayout } from '@upright/ui/common/upright/core/impact-lenses/net-impact/aggregate-result/layout';
import { AggregateMetricProps } from '@upright/ui/common/upright/model/output/scores/aggregate-metrics';
import { NetScoreBlock } from './index';

interface Props extends AggregateMetricProps {
  onContributeClick?: () => void;
}

export function NetScoreBlockEqualWeights(props: Props) {
  const netScore = useNetScoreWithoutValueSet(props.currentMetric);
  const layout = useAggregateResultAreaLayout();
  return (
    <NetScoreBlock
      bounds={layout.equalWeightsResultBounds()}
      netScore={netScore}
      valueSetName={EQUAL_WEIGHTS_TITLE}
      {...props}
    />
  );
}
